export type BoardUIState = {
  lockBoard: boolean
};

export const initialState: BoardUIState = {
  lockBoard: false
} as BoardUIState;
